// @flow
import React from 'react';

import {
  useSelector,
  useDispatch,
} from 'react-redux';

import type {
  Node,
  StatelessFunctionalComponent,
} from 'react';
import type {
  Worklog,
  Dispatch,
  GroupByType,
  DateTimeType,
  IntervalType,
} from 'chronos-types';

import * as actions from 'chronos-actions';
import * as selectors from 'chronos-selectors';
import {
  calculateCalendarSelection,
  calculateSidebarSelection,
} from 'chronos-utils';

import {
  Timeline,
} from 'chronos-components';

import {
  TimelineWrapper,
} from './styled';

type Worklogs = {
  [string]: {
    [string]: Worklog,
  }
}

type Props = {
  date: IntervalType,
  worklogs: Worklogs,
  groupBy: GroupByType,
  isGroupByOpen: boolean,
  sidebarSelection: { [string]: Array<string> },
  calendarSelection: Array<DateTimeType>,
  listWidth: number,
  dispatch: Dispatch,
  sidebarItems: Array<any>,
};

const mapState: Props = state => ({
  date: selectors.getUiState('calendarDate')(state),
  groupBy: selectors.getUiState('groupBy')(state),
  listWidth: selectors.getUiState('timelineListWidth')(state),
  sidebarItems: selectors.getSidebarItems(state),
  isGroupByOpen: selectors.getUiState('isGroupByOpen')(state),
  sidebarSelection: selectors.getUiState('sidebarSelection')(state),
  calendarSelection: selectors.getUiState('calendarSelection')(state),
  worklogs: selectors.getWorklogsMapGroupedByISODate(state),
  calendarSelectionArr: selectors.getUiState('calendarSelection')(state),
  status: selectors.getStatus(state, 'issues.requests.loadingFilterOptions.status'),
});

const TimelineContainer: StatelessFunctionalComponent<Props> = (): Node => {
  const {
    date,
    worklogs,
    groupBy,
    sidebarItems,
    calendarSelection,
    sidebarSelection,
    listWidth,
    status,
    isGroupByOpen,
    calendarSelectionArr,
  } = useSelector(mapState);

  const dispatch: Dispatch = useDispatch();

  return (
    <TimelineWrapper>
      <Timeline
        worklogs={worklogs}
        currentDate={date}
        sidebarItems={sidebarItems}
        groupBy={groupBy}
        isGroupByOpen={isGroupByOpen}
        selectedRows={sidebarSelection[groupBy]}
        selectedColumns={calendarSelection}
        worklogsFetching={status.pending}
        onGroupBy={(type) => {
          dispatch(actions.setUiState({
            groupBy: type,
          }));
          dispatch(actions.setUiState({
            isGroupByOpen: false,
          }));
        }}
        setGroupByVisible={(value) => {
          dispatch(actions.setUiState({
            isGroupByOpen: value,
          }));
        }}
        listWidth={listWidth}
        listResizeRequest={(width) => {
          if (width > 200) {
            dispatch(actions.setUiState({
              timelineListWidth: width,
            }));
          }
        }}
        selectRows={(id, event) => {
          dispatch(
            actions.setUiState({
              sidebarSelection: (
                calculateSidebarSelection(
                  sidebarSelection,
                  id,
                  groupBy,
                  event,
                )
              ),
            }),
          );
        }}
        onSelect={(newDate, event) => dispatch(
          actions.setUiState({
            calendarSelection: (
              calculateCalendarSelection(
                calendarSelectionArr,
                newDate,
                event,
              )
            ),
          }),
        )}
      />
    </TimelineWrapper>
  );
};

export default TimelineContainer;
